module.exports = __webpack_public_path__ + "media/components/dropdown-arrow-black-5a532ca3.svg";